import { useCheckout } from "@/context/CheckoutContext";
import { handleTrackedClick } from "@/utils/analytics";
import type { ButtonVariant } from "../ButtonPrimitive";
import { ButtonPrimitive } from "../ButtonPrimitive";
import { Icon } from "../Icon/Icon";

export interface CTAButtonProps {
  text: string;
  href?: string;
  offerId?: number;
  ofertaUrl?: string;
  variant?: ButtonVariant;
  size?: "sm" | "md" | "lg";
  goalName?: string;
  goalMetadata?: Record<string, unknown>;
  showIcon?: boolean;
  iconName?: string;
  className?: string;
  dataTrack?: string;
}

export function CTAButton({
  text,
  href = "#",
  offerId,
  ofertaUrl,
  variant = "secondary",
  size = "lg",
  goalName = "cta_click",
  goalMetadata = {},
  showIcon = true,
  iconName = "arrow-right",
  className = "",
  dataTrack,
}: CTAButtonProps) {
  const checkout = useCheckout();

  if (offerId) {
    return (
      <ButtonPrimitive
        as="button"
        type="button"
        variant={variant}
        size={size}
        coloredShadow
        className={className}
        data-component="CTAButton"
        data-track={dataTrack}
        onClick={() => {
          handleTrackedClick(null, `#checkout-${offerId}`, goalName, {
            buttonText: text,
            checkout: true,
            ...goalMetadata,
          });
          checkout.open({
            offerId,
            productTitle: text,
            productPrice: "",
            ofertaUrl,
          });
        }}
      >
        {text}
        {showIcon && <Icon name={iconName} size="lg" />}
      </ButtonPrimitive>
    );
  }

  return (
    <ButtonPrimitive
      as="a"
      variant={variant}
      size={size}
      coloredShadow
      className={className}
      href={href}
      data-component="CTAButton"
      data-track={dataTrack}
      onClick={(e: React.MouseEvent) =>
        handleTrackedClick(e, href, goalName, {
          buttonText: text,
          target: href,
          ...goalMetadata,
        })
      }
    >
      {text}
      {showIcon && <Icon name={iconName} size="lg" />}
    </ButtonPrimitive>
  );
}

CTAButton.displayName = "CTAButton";
